/* eslint-disable */

import PropTypes from 'prop-types';
// @mui
import { Avatar, Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// routes
// hooks
import useResponsive from '../../../hooks/useResponsive';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import { fDate } from '../../../utils/formatTime';
// components
import { ServerUtils } from '../../../api_utils';
import Iconify from '../../../components/Iconify';
import Image from '../../../components/Image';
import SvgIconStyle from '../../../components/SvgIconStyle';
import TextIconLabel from '../../../components/TextIconLabel';
import useSettings from '../../../hooks/useSettings';

// ----------------------------------------------------------------------

const OverlayStyle = styled('div')(({ theme, themeMode }) => ({
  top: 0,
  zIndex: 1,
  width: '100%',
  height: '100%',
  position: 'absolute',
  backgroundColor: alpha(theme.palette.grey[900], themeMode === "dark" ? 0.8 : 0.6),
}));

// ----------------------------------------------------------------------

BlogPostCard.propTypes = {
  post: PropTypes.object.isRequired,
  index: PropTypes.number,
};

export default function BlogPostCard({ post, index, onSelectPost }) {
  const isDesktop = useResponsive('up', 'md');

  const {themeMode} = useSettings()

  const { imageUrl, title, subtitle, content, created_at, poster, views } = post;

  const latestPost = index === 0 || index === 1 || index === 2;

  if (isDesktop && latestPost) {
    return (
      <Card onClick={onSelectPost} sx={{ height: '100%', cursor: 'pointer', transition: '.5s', '&:hover': { transform: 'scale(1.01)' } }}>
        <Stack
          direction="row"
          sx={{
            position: 'absolute',
            zIndex: 9,
            top: 24,
            left: 24,
          }}
          alignContent="center"
          alignItems="center"
          spacing={1}
        >
          <Avatar
            alt={poster.name}
            src={ServerUtils.getUserImageUrl(poster)}
            sx={{
              width: 40,
              height: 40,
            }}
          />
          <Stack>
            <Typography variant='subtitle1' style={{color: 'white'}}>{poster.name}</Typography>
            <Typography variant='caption' style={{ color: 'white' }}>{poster.username}</Typography>
          </Stack>

        </Stack>
        <PostContent title={title} subtitle={subtitle} view={views.length} comment={0} share={0} created_at={created_at} index={index} />
        <OverlayStyle themeMode={themeMode}/>
        <Image alt="cover" src={ServerUtils.getPostImageUrl(post)} sx={{ minHeight: 320, height: '100%' }} />
      </Card>
    );
  }

  return (
    <Card onClick={onSelectPost} sx={{ height: '100%', cursor: 'pointer', transition: '.5s', '&:hover': { transform: 'scale(1.01)' } }}>
      <Box sx={{ position: 'relative' }}>
        <SvgIconStyle
          src="../icons/ic_shape-avatar.svg"
          sx={{
            width: 80,
            height: 36,
            zIndex: 9,
            bottom: -15,
            position: 'absolute',
            color: 'background.paper',
          }}
        />
        <Avatar
          alt={poster.name}
          src={ServerUtils.getUserImageUrl(poster)}
          sx={{
            left: 24,
            zIndex: 9,
            width: 32,
            height: 32,
            bottom: -16,
            position: 'absolute',
          }}
        />
        <Image alt="cover" src={ServerUtils.getPostImageUrl(post)} ratio="4/3" />
      </Box>

      <PostContent title={title} subtitle={subtitle} view={views.length} comment={0} share={0} created_at={created_at} />
    </Card>
  );
}

// ----------------------------------------------------------------------

PostContent.propTypes = {
  comment: PropTypes.number,
  created_at: PropTypes.string,
  index: PropTypes.number,
  share: PropTypes.number,
  title: PropTypes.string,
  view: PropTypes.number,
};

export function PostContent({ title, subtitle, view, comment, share, created_at, index }) {
  const isDesktop = useResponsive('up', 'md');

  // const linkTo = `${PATH_DASHBOARD.blog.root}/post/${paramCase(title)}`;

  const latestPostLarge = index === 0;
  const latestPostSmall = index === 1 || index === 2;

  const POST_INFO = [
    // { number: comment, icon: 'eva:message-circle-fill' },
    { number: view, icon: 'eva:eye-fill' },
    // { number: share, icon: 'eva:share-fill' },
  ];

  return (
    <CardContent
      sx={{
        pt: 4.5,
        width: 1,
        ...((latestPostLarge || latestPostSmall) && {
          pt: 0,
          zIndex: 9,
          bottom: 0,
          position: 'absolute',
          color: 'common.white',
        }),
      }}
    >
      <Typography
        gutterBottom
        variant="caption"
        component="div"
        sx={{
          color: 'text.disabled',
          ...((latestPostLarge || latestPostSmall) && {
            opacity: 0.64,
            color: 'common.white',
          }),
        }}
      >
        {fDate(created_at)}
      </Typography>

      <Stack>
        {/* <Link to={linkTo} color="inherit" component={RouterLink}> */}
        <Typography variant={isDesktop && latestPostLarge ? 'h4' : 'subtitle1'}>
          {title}
        </Typography>
        <Typography variant={isDesktop && latestPostLarge ? 'body2' : 'subtitle1'} sx={{ color: 'text.disabled' }}>
          {subtitle}
        </Typography>
        {/* </Link> */}
      </Stack>

      <Stack
        flexWrap="wrap"
        direction="row"
        justifyContent="flex-end"
        sx={{
          mt: 3,
          color: 'text.disabled',
          ...((latestPostLarge || latestPostSmall) && {
            opacity: 0.64,
            color: 'common.white',
          }),
        }}
      >
        {POST_INFO.map((info, index) => (
          <TextIconLabel
            key={index}
            icon={<Iconify icon={info.icon} sx={{ width: 16, height: 16, mr: 0.5 }} />}
            value={fShortenNumber(info.number)}
            sx={{ typography: 'caption', ml: index === 0 ? 0 : 1.5 }}
          />
        ))}
      </Stack>
    </CardContent>
  );
}
